import React from 'react';
import { Button, Menu, MenuButton, Text, Wrap, useDisclosure, } from '@chakra-ui/react';
import Chevron, { ChevronDirection } from '../../icons/Chevron';
import { useTokens } from '../../../context/TokenProvider';
import MultiSelectChip from './MultiSelectChip';
import { RenderIf } from '../RenderIf/RenderIf';
import { makeReg3 } from '../../../styles/textStyles';
import { localise } from '../../../services/lang/lang';
const MultiSelectChipField = ({ children, chips, isDisabled, label, }) => {
    const tokens = useTokens();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const textStyle = makeReg3(tokens, { pl: tokens.Spacing03 });
    return (React.createElement(Menu, { variant: "multi-select", isOpen: isOpen, onClose: onClose, onOpen: onOpen, closeOnSelect: false },
        React.createElement(MenuButton, { "data-testid": "multi_select_chip_field", "aria-label": label, w: "full", variant: "white-grey", borderRadius: tokens.BorderRadius02, as: Button, height: "100%", isDisabled: isDisabled, padding: tokens.Spacing03, rightIcon: React.createElement(Chevron, { direction: isOpen ? ChevronDirection.UP : ChevronDirection.DOWN }) },
            React.createElement(Wrap, null,
                React.createElement(RenderIf, { condition: !chips.length },
                    React.createElement(Text, { "data-testid": "multi_select_chip_field__none_added", sx: textStyle }, localise('NONE_ADDED'))),
                chips.map((chip, index) => (React.createElement(MultiSelectChip, { handleKeyDown: () => { }, "data-id": index, key: chip.text, chip: chip }))))),
        children));
};
export default MultiSelectChipField;
